import { Box, Group, Text } from "@mantine/core";
import { FlagMap } from "../../utils/constants";

const FlagIcon = ({ code, size = 14 }) => {
  if (!code) return null;
  const Flag = FlagMap[code];
  if (!Flag) return null;
  return (
    <Box
      style={{
        width: size * 1.4,
        height: size,
        overflow: "hidden",
        borderRadius: 2,
        flexShrink: 0,
        display: "inline-flex",
      }}
    >
      <Flag style={{ width: "100%", height: "100%" }} />
    </Box>
  );
};

const CountryCell = ({ code, name, showName = false, size = 14 }) => {
  if (!code) {
    return (
      <Text size="sm" c="dimmed">
        —
      </Text>
    );
  }
  return (
    <Group gap={6} wrap="nowrap" align="center" style={{ minWidth: 0 }}>
      <FlagIcon code={code} size={size} />
      <Text size="sm" style={{ lineHeight: 1 }}>
        {code}
      </Text>
      {showName && name && (
        <Text size="xs" c="dimmed" truncate>
          {name}
        </Text>
      )}
    </Group>
  );
};

export { FlagIcon };
export default CountryCell;
